const translations = {
    batteryCycles: 'Battery cycles',
    droneSerialNumber: 'Drone S/N',
    expired: 'Expired',
    faaRegistration: 'FAA reg #',
    firmware: 'Firmware',
    lastLevelCalibration: 'Last level calibration',
    lastMagnetometerCalibration: 'Last magnetometer calibration',
    lastPumpCalibration: 'Last pump calibration',
    lastWeightCalibration: 'Last weight calibration',
    totalFlightHours: 'Total flight hours',
    warrantyEnd: 'Wty. end',
    warrantyRemaining: 'Wty. rmng',
    warrantyStart: 'Wty. start'
};

export default translations;
